var getCleanValue = function (value) {
    if (typeof value === 'string') {
        return new Date(value);
    }
    return value || undefined;
};
export var getCleanValues = function (value) {
    var from = getCleanValue(value === null || value === void 0 ? void 0 : value[0]);
    var to = getCleanValue(value === null || value === void 0 ? void 0 : value[1]);
    return [from, to];
};
